import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Link } from "react-router-dom";

export default function ColorSlider() {
  const swiperRef = useRef(null);
  const [colors, setColors] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(API_URL + "colors")
      .then((res) => {
        setColors(res.data);
      })
      .catch((err) => {
        console.error("Failed to load colors", err);
      });
  }, []);

  return (
    <div className="container">
      <div className="row mt-5 mb-5">
        <div className="col-12 position-relative">

          {/* LEFT NAV */}
          <button
            onClick={() => swiperRef.current?.slidePrev()}
            style={{
              position: "absolute",
              top: "50%",
              left: "120px",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              border: "1px solid #ddd",
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              cursor: "pointer",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="black" strokeWidth="2" />
            </svg>
          </button>

          {/* RIGHT NAV */}
          <button
            onClick={() => swiperRef.current?.slideNext()}
            style={{
              position: "absolute",
              top: "50%",
              right: "120px",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              border: "1px solid #ddd",
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              cursor: "pointer",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 6l6 6-6 6" stroke="black" strokeWidth="2" />
            </svg>
          </button>

          {/* SWIPER */}
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            slidesPerView="auto"
            spaceBetween={16}
            loop={true}
          >
            {colors.map((c) => (
              <SwiperSlide key={c.id} style={{ width: "auto" }}>
                <div style={{ textAlign: "center" }}>
                  
                    <img
                      src={c.image}
                      alt={c.name}
                      style={{
                        width: "140px",
                        height: "140px",
                        borderRadius: "12px",
                        objectFit: "cover",
                        margin: "0 auto",
                      }}
                      onError={(e) => {
                        e.target.src = "/images/placeholder.png";
                      }}
                    />
                  

                  <p
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      fontWeight: "600",
                    }}
                  >
                    {c.name}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {colors.length === 0 && (
            <p className="text-center mt-3">No colors found</p>
          )}
        </div>
      </div>
    </div>
  );
}
